import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { gsap } from 'gsap';
import { lg, md, wide, xl, xl2, xwide } from '../common';

export function initBlockCredits01(parent) {
  if (!parent) return;

  const swiper = parent.querySelector('.swiper');

  new Swiper(swiper, {
    modules: [Autoplay],
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    autoplay: { delay: 3000 },
    breakpoints: {
      [md]: { spaceBetween: 12 },
      [xl]: { spaceBetween: 16 },
      [xl2]: { spaceBetween: 20 },
      [wide]: { spaceBetween: 24 },
      [xwide]: { spaceBetween: 32 },
    },
  });
}

export function initBlockCredits01s() {
  const blocks = document.querySelectorAll('.block-credits-01');
  blocks.forEach((block) => initBlockCredits01(block));
}
